import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-10 col-lg-10 col-xl-12 col-xxl-10 col-xxxl-9" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = { class: "mb-3" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Terminez la creation du compte ", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isInvalid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[15] || (_cache[15] = [
                  _createElementVNode("p", { class: "fs-md-15 fs-lg-16" }, " Ce lien est invalide. ", -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isInvalid)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRegister && _ctx.handleRegister(...args)), ["prevent"])),
                class: "row g-3"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", {
                      for: "name",
                      class: "form-label"
                    }, "Nom et prénom *", -1)),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "name",
                      value: _ctx.customerData.name,
                      name: "name",
                      placeholder: "Nom et prénom *",
                      disabled: ""
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", {
                      for: "email",
                      class: "form-label"
                    }, "Adresse electronique *", -1)),
                    _createElementVNode("input", {
                      type: "email",
                      class: "form-control",
                      id: "email",
                      value: _ctx.customerData.email,
                      name: "email",
                      disabled: ""
                    }, null, 8, _hoisted_12)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", {
                      for: "store_name",
                      class: "form-label"
                    }, "Votre Store", -1)),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "store_name",
                      value: _ctx.customerData.store_name,
                      name: "store_name",
                      placeholder: "Votre store",
                      disabled: ""
                    }, null, 8, _hoisted_15)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", {
                      for: "phone",
                      class: "form-label"
                    }, "Numéro de téléphone *", -1)),
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "phone",
                      value: _ctx.customerData.phone,
                      name: "phone",
                      placeholder: "Numéro de téléphone *",
                      disabled: ""
                    }, null, 8, _hoisted_18)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                      for: "store",
                      class: "form-label"
                    }, "Nom du magasin *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "store",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customerData.store_name) = $event)),
                      name: "store",
                      placeholder: "Nom du magasin *",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.store_name]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", {
                      for: "brand",
                      class: "form-label"
                    }, "Marque *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "brand",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customerData.brand) = $event)),
                      name: "brand",
                      placeholder: "Marque *",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.brand]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", {
                      for: "city",
                      class: "form-label"
                    }, "Ville *", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      modelValue: _ctx.customerData.city,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customerData.city) = $event)),
                      label: "name",
                      options: _ctx.citiesList
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", {
                      for: "cityReturn",
                      class: "form-label"
                    }, "Ville de retour *", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      modelValue: _ctx.customerData.cityReturn,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customerData.cityReturn) = $event)),
                      options: _ctx.citiesList,
                      label: "name"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", {
                      for: "address",
                      class: "form-label"
                    }, "Adresse *", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      id: "address",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerData.address) = $event)),
                      name: "address",
                      rows: "2",
                      placeholder: "Adresse *",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.address]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", {
                      for: "password",
                      class: "form-label"
                    }, "Mot de passe *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      id: "password",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customerData.password) = $event)),
                      name: "password",
                      placeholder: "*****",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.password]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", {
                      for: "c_password",
                      class: "form-label"
                    }, "Confirmation de mot de passe *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      id: "c_password",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customerData.c_password) = $event)),
                      name: "c_password",
                      placeholder: "Confirmation de mot de passe *",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.c_password]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", {
                      for: "cin",
                      class: "form-label"
                    }, "Carte d'identité nationale *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "cin",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customerData.cin) = $event)),
                      name: "cin",
                      placeholder: "Carte d'identité nationale *",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.cin]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", {
                      for: "company_type",
                      class: "form-label"
                    }, "Type d'entereprise *", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      modelValue: _ctx.customerData.company_type,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customerData.company_type) = $event)),
                      label: "name",
                      options: _ctx.typeClients
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", {
                      for: "rc",
                      class: "form-label"
                    }, "RC", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "rc",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customerData.rc) = $event)),
                      name: "rc",
                      placeholder: "RC"
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.rc]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[30] || (_cache[30] = _createElementVNode("label", {
                      for: "ice",
                      class: "form-label"
                    }, "ICE", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "ice",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customerData.ice) = $event)),
                      name: "ice",
                      placeholder: "ICE"
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.ice]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                      for: "website",
                      class: "form-label"
                    }, "Site web", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "url",
                      class: "form-control",
                      id: "website",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.customerData.website) = $event)),
                      name: "website",
                      placeholder: "www.monsite.ma"
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.website]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", {
                      for: "bank",
                      class: "form-label"
                    }, "Nom du banque *", -1)),
                    _createVNode(_component_v_select, {
                      class: "custom-select-height",
                      modelValue: _ctx.customerData.bank,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.customerData.bank) = $event)),
                      label: "name",
                      options: _ctx.bankList
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                      for: "rib",
                      class: "form-label"
                    }, "RIB (24 Numéro) *", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "rib",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.customerData.rib) = $event)),
                      name: "rib",
                      placeholder: "RIB (24 Numéro) *",
                      maxlength: "24",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.customerData.rib]
                    ])
                  ])
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-12" }, [
                  _createElementVNode("hr")
                ], -1)),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary w-100",
                    disabled: _ctx.isInvalid || _ctx.load
                  }, [
                    _cache[34] || (_cache[34] = _createTextVNode(" Terminer ", -1)),
                    (_ctx.load)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_48)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}